// import React from "react";
// import pic1 from "../../assets/mocks/Screenshot 2024-05-19 at 12.38 1.png";
// import pic2 from "../../assets/mocks/Screenshot 2024-05-19 at 12.42 1.png";
// import pic3 from "../../assets/mocks/Screenshot 2024-05-19 at 12.42 2.png";
// const Project4 = () => {
//   return (
//     <div className="bg-indigo-800 h-full flex gap-4 justify-center">
//       <img src={pic1} alt="" srcset="" className="mt-[25%] h-[40%]" />
//       <img src={pic2} alt="" srcset="" className="my-auto h-[40%]" />
//       <img src={pic3} alt="" srcset="" className="mt-[55%] h-[40%]" />
//     </div>
//   );
// };

// export default Project4;
import React from "react";
import Calc from "../../assets/mocks/Calculator.png";
const Project4 = () => {
  return (
    <div className="bg-blue-300 h-full flex justify-center items-center">
      <img src={Calc} alt="" srcset="" />
    </div>
  );
};

export default Project4;
